import { SuspenseWrapper } from "@/lib/main";
import type { ReactNode } from "react";

const routeElement = (element: ReactNode) => {
  return <SuspenseWrapper>{element}</SuspenseWrapper>;
};

export default routeElement;
